/* eslint-disable max-lines */
import store from '@/store/index';
const { user } = store.getters;
export const tableConfig = {
    name: 'contractRegistration',
    columns: [
        {
            label: '单据编号',
            prop: 'contractCode',
            width: 130
        },
        {
            label: '分公司',
            prop: 'companyName',
            width: 100
        },
        {
            label: '客户名称',
            prop: 'customerName',
            width: 160
        },
        {
            label: '细分等级',
            prop: 'calCustomerLevel',
            type: 'slot',
            slot: true,
            optionsKey: 'NEOCRM_CUSTOMER_LEVEL',
            width: 120
        },
        {
            label: '到期规模（万元）',
            prop: 'contractScale',
            width: 120
        },
        {
            label: '终止原因大类',
            prop: 'exitStatus',
            type: 'select',
            optionsKey: 'CRM_CONTRACT_EXIT_STATUS',
            width: 110
        },
        {
            label: '终止原因小类',
            prop: 'causeCategories',
            type: 'select',
            optionsKey: 'CRM_CONTRACT_CAUSE_CATEGORIES',
            width: 170
        },
        {
            label: '终止细分原因',
            prop: 'causeSubcategory',
            type: 'select',
            optionsKey: 'CRM_CONTRACT_CAUSE_SUBCATEGORY',
            width: 150
        },
        {
            label: '附件',
            prop: 'file',
            type: 'slot',
            slot: true,
            width: 80
        },
        {
            label: '行业大类',
            prop: 'industryCategories',
            width: 120
        },
        {
            label: '客户系名称',
            prop: 'customerGroupName',
            width: 120
        },
        {
            label: '片区',
            prop: 'region',
            width: 80
        },
        {
            label: '续签状态',
            prop: 'renewalStatus',
            type: 'select',
            optionsKey: 'CRM_CONTRACT_RENEWAL_STATUS',
            width: 90
        },
        {
            label: '历史采购毛利率(%)',
            prop: 'historyGrossMargin',
            width: 130
        },
        {
            label: '历史经营中心利润率(%)',
            prop: 'historyOperateGrossMargin',
            width: 130
        },
        {
            label: '安得投标价格与安得历史价格差距(%)',
            prop: 'bidAndHistoryPriceGap',
            width: 150
        },
        {
            label: '中标价格与安得投标价格差异(%)',
            prop: 'winningAndBidPriceGap',
            width: 150
        },
        {
            label: '下游涨降幅度(%)',
            prop: 'downstreamAmplitude',
            width: 120
        },

        {
            label: '应收金额（万元）',
            prop: 'receivableAmount',
            width: 120
        },
        {
            label: '逾期未开票（万元）',
            prop: 'overdueNoInvoicedAmount',
            width: 130
        },
        {
            label: '逾期已开票（万元）',
            prop: 'overdueInvoicedAmount',
            width: 130
        },
        {
            label: '押金金额（万元）',
            prop: 'depositAmount',
            width: 120
        },
        {
            label: '终止原因',
            prop: 'terminationCause',
            width: 120
        },
        {
            label: '业务类型',
            prop: 'businessType',
            optionsKey: 'SYS_BMS_BUSI_TYPE',
            type: 'slot',
            slot: true,
            width: 180
        },
        {
            label: '业务结构（仓库类型）',
            prop: 'warehouseType',
            type: 'slot',
            slot: true,
            // type: 'select',
            optionsKey: 'NEOCRM_WH_TYPE',
            width: 150
        },
        {
            label: '生效日期',
            prop: 'validTime',
            width: 160
        },
        {
            label: '合同失效日期',
            prop: 'failTime',
            width: 160
        },
        {
            label: '提前终止时间',
            prop: 'earlyTerminationTime',
            width: 120
        },
        {
            label: '提前续签/延期时间',
            prop: 'advanceOrDelayTime',
            width: 160
        },
        {
            label: '续签风险',
            prop: 'renewalRisk',
            type: 'slot',
            slot: true,
            optionsKey: 'CRM_CONTRACT_RENEWAL_RISK',
            width: 90
        },
        {
            label: '风险原因',
            prop: 'riskCause',
            // type: 'select',
            type: 'slot',
            slot: true,
            optionsKey: 'CRM_CONTRACT_RENEWAL_RISK_CAUSE',
            width: 160
        },
        {
            label: '中标供应商名称（全称）',
            prop: 'winningSupplierName',
            width: 160
        },
        {
            label: '备注/续签支持项',
            prop: 'remark',
            width: 140
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 80, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        displayEditRule: () => {
            return false;
        },
        list: [
            {
                label: '删除',
                event: 'del',
                displayRule: (row) => {
                    return true;
                }
            }
        ]
    },
    registractionAdvanceParams: {
        advanceLabel: '续签合同登记选择',
        label: '续签合同登记选择',
        name: '续签合同登记选择',
        prop: 'contractCodes',
        value: 'contractCodes',
        labelWidth: '150px',
        dialogWidth: '1300px',
        selection: true,
        type: 'custom',
        focusShowDialog: true,
        visible: true,
        multiple: true,
        border: true,
        disabledDbClick: true,
        firstNoFetch: false,
        advanceConfig: [
            {
                value: '单据编号(支持多个)',
                prop: 'contractCodes'
            },
            {
                name: '分公司',
                prop: 'companyNames',
                type: 'advanceMulti',
                isFixed: true,
                span: 3,
                advanceConfig: [
                    { 'prop': 'companyName', 'value': '分公司名称' },
                    { 'prop': 'companyCode', 'value': '分公司编码' },
                    { 'prop': 'region', 'value': '片区' }
                ],
                tableConfig: [
                    { 'prop': 'companyCode', 'value': '分公司编码' },
                    { 'prop': 'companyName', 'value': '分公司名称', 'displayName': 'companyName' },
                    { 'prop': 'region', 'value': '片区' }
                ],
                prefix: '/api-lcrm',
                advanceUrl: `/company/manager/archive/page`,
                method: 'post',
                cbParams: ['companyCode', 'companyName']
            },
            {
                name: '客户名称',
                prop: 'customerName',
                type: 'advance',
                isFixed: true,
                span: 3,
                advanceConfig: [
                    { prop: 'nameCn', value: '客户名称' },
                    { prop: 'customerCode', value: '客户编码' }
                ],
                tableConfig: [
                    { prop: 'customerCode', value: '客户编码' },
                    { prop: 'nameCn', value: '客户名称' }
                ],
                prefix: '/api-dc',
                advanceUrl: '/customers',
                cbParams: ['customerCode', 'nameCn#customerName'],
                advanceCode: 'advanceCode'
            },
            {
                name: '客户系',
                prop: 'customerGroupName',
                type: 'advance',
                isFixed: true,
                span: 3,
                advanceConfig: [
                    { prop: 'customerGroupName', value: '客户系名称' }
                ],
                tableConfig: [
                    { prop: 'customerGroupName', value: '客户系名称' },
                    { prop: 'calCustomerLevelCode', value: '客户等级', type: 'select', optionsKey: 'NEOCRM_CUSTOMER_LEVEL' },
                    { prop: 'customerGroupCode', value: '行业类型', type: 'select', optionsKey: 'SYS_INDUSTRY_TYPE' },
                    { prop: 'industryCategory', value: '行业大类', type: 'select', optionsKey: 'SRM_SUPPLIER_INDUSTRY' }
                ],
                prefix: '/api-lcrm',
                advanceUrl: '/customer/group/info/page',
                cbParams: ['customerGroupCode#customerGroupCodeList', 'customerGroupName'],
                advanceCode: 'advanceCode'
            }
        ],
        tableConfig: [
            // { 'prop': 'maintainStatus', 'value': '状态', width: '130px', type: 'select', optionsKey: 'MANAGER_ARCHIVE_MAINTAIN_STATUS' },
            // { 'prop': 'customerGroupCode', 'value': '客户系', width: '110px', type: 'select', optionsKey: 'SYS_CUST_RELATION_TYPE' },
            // { 'prop': 'customerName', 'value': '客户名称', 'displayName': 'customerName' },
            {
                value: '单据编号',
                prop: 'contractCode',
                width: 130,
                'displayName': 'contractCode'
            },
            {
                value: '分公司',
                prop: 'companyName',
                width: 100,
                'displayName': 'companyName'
            },
            {
                value: '客户名称',
                prop: 'customerName',
                width: 160,
                'displayName': 'customerName'
            },
            {
                value: '细分等级',
                prop: 'calCustomerLevel',
                type: 'slot',
                slot: true,
                optionsKey: 'NEOCRM_CUSTOMER_LEVEL',
                width: 120
            },
            {
                value: '到期规模（万元）',
                prop: 'contractScale',
                width: 120
            },
            {
                value: '终止原因大类',
                prop: 'exitStatus',
                type: 'select',
                optionsKey: 'CRM_CONTRACT_EXIT_STATUS',
                width: 110
            },
            {
                value: '终止原因小类',
                prop: 'causeCategories',
                type: 'select',
                optionsKey: 'CRM_CONTRACT_CAUSE_CATEGORIES',
                width: 170
            },
            {
                value: '终止细分原因',
                prop: 'causeSubcategory',
                type: 'select',
                optionsKey: 'CRM_CONTRACT_CAUSE_SUBCATEGORY',
                width: 150
            },
            {
                value: '附件',
                prop: 'file',
                type: 'slot',
                slot: true,
                width: 80
            },
            {
                value: '行业大类',
                prop: 'industryCategories',
                width: 120
            },
            {
                value: '客户系名称',
                prop: 'customerGroupName',
                width: 120
            },
            {
                value: '片区',
                prop: 'region',
                width: 80
            },
            {
                value: '续签状态',
                prop: 'renewalStatus',
                type: 'select',
                optionsKey: 'CRM_CONTRACT_RENEWAL_STATUS',
                width: 90
            },
            {
                value: '历史采购毛利率(%)',
                prop: 'historyGrossMargin',
                width: 130
            },
            {
                value: '历史经营中心利润率(%)',
                prop: 'historyOperateGrossMargin',
                width: 130
            },
            {
                value: '安得投标价格与安得历史价格差距(%)',
                prop: 'bidAndHistoryPriceGap',
                width: 150
            },
            {
                value: '中标价格与安得投标价格差异(%)',
                prop: 'winningAndBidPriceGap',
                width: 150
            },
            {
                value: '下游涨降幅度(%)',
                prop: 'downstreamAmplitude',
                width: 120
            },
            {
                value: '应收金额（万元）',
                prop: 'receivableAmount',
                width: 120
            },
            {
                value: '逾期未开票（万元）',
                prop: 'overdueNoInvoicedAmount',
                width: 130
            },
            {
                value: '逾期已开票（万元）',
                prop: 'overdueInvoicedAmount',
                width: 130
            },
            {
                value: '押金金额（万元）',
                prop: 'depositAmount',
                width: 120
            },
            {
                value: '终止原因',
                prop: 'terminationCause',
                width: 120
            },
            {
                value: '业务类型',
                prop: 'businessType',
                optionsKey: 'SYS_BMS_BUSI_TYPE',
                type: 'slot',
                slot: true,
                width: 180
            },
            {
                value: '业务结构（仓库类型）',
                prop: 'warehouseType',
                type: 'slot',
                slot: true,
                // type: 'select',
                optionsKey: 'NEOCRM_WH_TYPE',
                width: 150
            },
            {
                value: '生效日期',
                prop: 'validTime',
                width: 160
            },
            {
                value: '合同失效日期',
                prop: 'failTime',
                width: 160
            },
            {
                value: '提前终止时间',
                prop: 'earlyTerminationTime',
                width: 120
            },
            {
                value: '提前续签/延期时间',
                prop: 'advanceOrDelayTime',
                width: 160
            },
            {
                value: '续签风险',
                prop: 'renewalRisk',
                type: 'slot',
                slot: true,
                optionsKey: 'CRM_CONTRACT_RENEWAL_RISK',
                width: 90
            },
            {
                value: '风险原因',
                prop: 'riskCause',
                type: 'slot',
                slot: true,
                optionsKey: 'CRM_CONTRACT_RENEWAL_RISK_CAUSE',
                width: 160
            },
            {
                value: '中标供应商名称（全称）',
                prop: 'winningSupplierName',
                width: 160
            },
            {
                value: '备注/续签支持项',
                prop: 'remark',
                width: 140
            }
        ],
        MultipleConfig: {
            NoInsertFirstConfig: true,
            method: 'post',
            // prefix: 'pms-template',
            advanceCascade: { param: {} },
            tableConfig: [
                {
                    prop: 'contractCode',
                    value: '单据编号'
                },
                {
                    prop: 'companyName',
                    value: '分公司'
                },
                {
                    prop: 'customerName',
                    value: '客户名称'
                }
            ]
        },
        otherMultiple: [{ prop: 'id' }, { prop: 'fileListCn' }, { prop: 'renewalDeFlowStatus' }],
        // searchObj: {
        // key: '',
        // keyword: ''
        // },
        prefix: 'api-lcrm',
        method: 'post',
        searchType: 'input',
        advanceUrl: '/contract/renewal/registration/page',
        splitType: '|-,',
        cbParams: ['id', 'contractCode', 'companyName', 'customerName', 'calCustomerLevel', 'contractScale', 'exitStatus', 'renewalDeFlowStatus',
            'causeSubcategory', 'fileListCn', 'industryCategories', 'customerGroupName', 'region', 'renewalStatus', 'historyGrossMargin',
            'bidAndHistoryPriceGap', 'winningAndBidPriceGap', 'receivableAmount', 'depositAmount', 'terminationCause', 'warehouseType',
            'validTime', 'earlyTerminationTime', 'advanceOrDelayTime', 'renewalRisk', 'riskCause', 'winningSupplierName', 'remark', 'failTime', 'downstreamAmplitude',
            'causeCategories', 'historyOperateGrossMargin', 'businessType', 'overdueNoInvoicedAmount', 'overdueInvoicedAmount'
        ],
        beforeRequest: (params) => {
            params.orderBy = 'fail_time';
            params.orderByType = 'desc';
            params.userCode = user.userCode;
            if (!params.includeFlowCode) { //  沒有includeFlowCode 传下面的参数, 其他后端处理
                params.renewalFlowStatusList = ['7', '8']; // 作废、空
                params.renewalDeFlowStatusList = ['7', '8']; // 作废、空
            }
            if (!params.customerName) {
                delete params.customerCode;
            }
            if (!params.companyNames) {
                delete params.companyCodes;
            }
            if (!params.customerGroupName) {
                delete params.customerGroupCodeList;
            }
            Object.keys(params).forEach(v => {
                if (params[v] === undefined || params[v] === null || params[v] === '') {
                    delete params[v];
                }
            });
            if (params.calCustomerLevelCodes) {
                params.calCustomerLevelCodes = params.calCustomerLevelCodes && params.calCustomerLevelCodes.split(',');
            }
            if (params.customerGroupCodeList) {
                params.customerGroupCodeList = params.customerGroupCodeList && params.customerGroupCodeList.split(',');
            }
            return params;
        },
        afterResponse: (res) => {
            if (res && +res.code === 0 && res.data.list) {
                res.data.list = res.data.list.map(it => {
                    it.fileListCn = JSON.stringify(it.file || []);
                    return it;
                });
            }
            return res;
        }
    }
};
